import React from "react";
import { Sidebar } from "primereact/sidebar";
import { useApolloClient } from "@apollo/client";

import SETTINGS from "../provider/Settings/query";

export const SettingsContext = React.createContext({});

export const SettingsProvider = (props: any) => {
    const apollo = useApolloClient();
    const [settings, setSettings] = React.useState({});

    const [visibleError, setVisibleError] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    const loadSetting = () => {
        const data = localStorage.getItem("@onsidetechcurrent_settings");
        if (data) setSettings(JSON.parse(data));

        apollo
            .query({ query: SETTINGS, variables: {} })
            .then(info => {
                setSettings(info.data.settings);
                localStorage.setItem("@onsidetechcurrent_settings", JSON.stringify(info.data.settings));
            })
            .catch(error => {});
    };

    React.useEffect(() => {
        loadSetting();
    }, []);

    return (
        <SettingsContext.Provider value={{ ...settings, loadSetting: loadSetting, setVisibleError, setErrorMessage }}>
            {props.children}
            <Sidebar visible={visibleError} onHide={() => setVisibleError(false)} baseZIndex={1000000} position="bottom">
                <h3 style={{ fontWeight: "normal" }} className="text-center">
                    {errorMessage}
                </h3>
            </Sidebar>
        </SettingsContext.Provider>
    );
};

export const useSettings = () => React.useContext<any>(SettingsContext);
